import {Component, Input, OnInit} from '@angular/core';
import {Offer} from '../../../../../core/models/offer/offer.model';

@Component({
  selector: 'app-offer-price',
  templateUrl: './offer-price.component.html',
  styleUrls: []
})
export class OfferPriceComponent implements OnInit {

  @Input() hasModifications: boolean = false;
  @Input() offer: Offer;
  @Input() currentModificationsPrice: number;
  @Input() loading: boolean = false;
  @Input() selectedPremium: string;
  @Input() showInstallment: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
